import { useNode } from "@craftjs/core";
import React, { useContext, useEffect } from "react";
import { SiteTitleSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
// import { GrigoraEditorContext } from "../../editor/context";
import icon from "./icon";
import { GrigoraDashboardContext } from "../../dashboard/context";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const SiteTitle = (props) => {
  const { project } = useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    siteTitle = "Site Title",
    structureTag = "h1",
    linkSite,
    openInNewTab,
    link = "#",
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-site-title": true,
      [`site-title-${id}`]: id,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  const Tag = structureTag;

  const content = linkSite ? (
    <a
      target={`${openInNewTab == true ? "_blank" : "_self"}`}
      href={link}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      {project?.name ? <Tag>{project.name}</Tag> : <Tag>{siteTitle}</Tag>}
    </a>
  ) : (
    <>{project?.name ? <Tag>{project.name}</Tag> : <Tag>{siteTitle}</Tag>}</>
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__SiteTitle(id, props)}`}</style>
      {content}
    </div>
  );
};

// To Avoid Mangling in Production
SiteTitle.displayName = "SiteTitle";

SiteTitle.craft = {
  name: "Site Title",
  props: {},
  related: {
    settings: SiteTitleSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "site",
  },
  custom: {
    name: "SiteTitle",
    slug: "grigora/site-title",
  },
};
